import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/common/more-icon.png';

const _withScopeId = n => (_pushScopeId("data-v-197213a8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "online-card"
};
const _hoisted_2 = {
  key: 0,
  class: "online-link"
};
const _hoisted_3 = ["href"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "path-tips"
}, [/*#__PURE__*/_createElementVNode("p", null, "新版学堂"), /*#__PURE__*/_createElementVNode("div", {
  class: "btn"
}, [/*#__PURE__*/_createTextVNode(" 进入 "), /*#__PURE__*/_createElementVNode("span", {
  class: "arrow-icon"
})])], -1));

const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = ["href"];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "path-tips"
}, [/*#__PURE__*/_createElementVNode("p", null, "旧版学堂"), /*#__PURE__*/_createElementVNode("div", {
  class: "btn"
}, [/*#__PURE__*/_createTextVNode(" 进入 "), /*#__PURE__*/_createElementVNode("span", {
  class: "arrow-icon"
})])], -1));

const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  key: 1,
  class: "left"
};
const _hoisted_10 = {
  class: "left-on"
};
const _hoisted_11 = ["href"];

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "icon"
}, null, -1));

export default {
  props: {
    onlineLink: String,
    zhsRole: Number
  },

  setup(__props) {
    const $http = inject('$http');
    const newOnlineLink = ref('');

    const getNewOnlineLink = async () => {
      const res = await $http.getNewOnlineCourseUrl();
      newOnlineLink.value = res;
    };

    getNewOnlineLink();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.zhsRole == 2 && newOnlineLink.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("a", {
        href: newOnlineLink.value,
        class: "new-path",
        target: "_blank"
      }, _hoisted_5, 8, _hoisted_3), _createElementVNode("a", {
        href: __props.onlineLink,
        target: "_blank",
        class: "old-path"
      }, _hoisted_8, 8, _hoisted_6)])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("a", {
        href: __props.onlineLink,
        target: "_blank",
        class: "onlink"
      }, [_createTextVNode(_toDisplayString(_ctx.$schoolId == 5141 ? 'AI教学中心' : '在线学堂') + " ", 1), _hoisted_12], 8, _hoisted_11)])]))]);
    };
  }

};